import {Component, Input, OnInit} from '@angular/core';
import {MainComponent} from 'app/core/main.component';
import {AppService} from 'app/services/app.service';
import {NavigationService} from 'app/services/navigation.service';
import {UserModelService} from 'app/models/user-model.service';
import {ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  // encapsulation: ViewEncapsulation.None
})

export class MenuComponent extends MainComponent implements OnInit {

  @Input() menuRoutes: any[];

  constructor(
    appService: AppService,
    navigationService: NavigationService,
    userModelService: UserModelService,
  ) {
    super(appService, navigationService, userModelService);
  }

  ngOnInit() {
  }

  onClickMenuRoute(path: string) {
    if (path === 'exit') {
      this.appService.menuClose().then(() => {
        this.userModelService.logout();
        this.navigationService.goTo('authentication', {}, true);
      });
    } else {
      this.appService.menuClose();
      this.navigationService.goTo(path);
    }
  }

  isActiveRoute(route) {
    // console.log('route', route);
    // console.log(this.navigationService.isCurrentUrl(route.path));
    return this.navigationService.isCurrentUrl(route.path);
  }

}
